import * as yup from 'yup';
import { nullableImageFromCMSSchema } from '../schemas';

export const schema = yup
  .object({
    title: yup.string(),
    copy: yup.string(),
    image: nullableImageFromCMSSchema,
    promoCode: yup.string(),
  })
  .transform(value => ({
    title: value.title,
    copy: value.copy,
    image: value.image,
    promoCode: value.promo_code,
  }));
